export enum VersionVariants {
  VERSION_ONE = 'version_one',
  VERSION_TWO = 'version_two',
  VERSION_THREE = 'version_three',
  VERSION_FOUR = 'version_four',
  VERSION_FIVE = 'version_five',
  VERSION_SIX = 'version_six',
  VERSION_HIRIST = 'version_hirist',
  VERSION_HIRIST_V1 = 'version_hirist_v1',
  VERSION_SEVEN = 'version_seven',
  VERSION_EIGHT = 'version_eight',
}
